class OmetriaTracker {
	constructor(ometria) {
		this.ometria = ometria;
		this.ometriaAccountId = ometriaAccountId || false;
		this.ometriaFormId = ometriaFormId || false;
		this.useGlobalId = false;

		// check subscription form
		const omForm = document.getElementById("om-form");
		if (omForm && this.ometriaAccountId && this.ometriaFormId) {
			const account = omForm.querySelector("input[name='@account']");
			const formId = omForm.querySelector("input[name='__form_id']");

			if (!account || !formId) return;
			account.value = this.ometriaAccountId;
			formId.value = this.ometriaFormId;

			omForm.addEventListener("submit", () => {
				const ue = omForm.querySelector("input[name='ue']")?.value || false;
				if (ue) this.ometria.identify(ue);
			});

			const submitSuccess = getUrlParam("ometria_form_ok");
			if (submitSuccess && typeof showModal === "function") {
				removeUrlParam("ometria_form_ok");
				showModal({ txtHeader: "Successfully subscribed", txtBody: "Thank you for subscribing!" });
			}
		}
	}

	formatItemId(globalId) {
		if (this.useGlobalId) return globalId;
		return globalId.replace(/\D+/g, "");
	}

	identify(customerId) {
		// User ID tracking
		this.ometria.identify(customerId ? `omid:${this.formatItemId(customerId)}` : null);
		this.pageView();
	}

	setProductId() {
		const productOption = document.querySelector("#product-variants option");
		return { pid: this.formatItemId(productOption.getAttribute("data-product-id")) };
	}

	setBasket(checkoutObj) {
		if (!checkoutObj) return;
		if (!Array.isArray(checkoutObj?.lines?.nodes)) return;

		const lineItems = checkoutObj.lines.nodes;

		const basket = new this.ometria.Basket();
		basket.setId(checkoutObj.id);
		basket.setUrl(checkoutObj.checkoutUrl);
		basket.setTotal(parseFloat(checkoutObj.cost.subtotalAmount.amount), checkoutObj.cost.subtotalAmount.currencyCode);
		lineItems.forEach((item) => {
			basket.addLineItem(
				this.formatItemId(item.merchandise.product.id),
				item.quantity,
				parseFloat(item.merchandise.price.amount),
				this.formatItemId(item.merchandise.id)
			);
		});
		this.ometria.setBasket(basket);
	}

	pageView() {
		const { pathname } = window.location;
		const path = pathname.split("/")[1];

		switch (path) {
			case "":
				this.ometria.init("homepage", null, "default");
				break;
			case "collections":
				this.ometria.init("listing", null, "default");
				break;
			case "products":
				this.ometria.init("product", this.setProductId(), "default");
				break;
			case "cart":
				this.ometria.init("basket", null, "default");
				break;
			case "delivery-details":
				this.ometria.init("checkout", null, "default");
				break;
			default:
				this.ometria.init("other", null, "default");
		}
	}
}

window.addEventListener("load", () => {
	if (window.ometria) {
		window.OmetriaTracker = new OmetriaTracker(window.ometria);
	} else {
		console.warn("Ometria tracker not loaded");
	}
});
